<template>
  <div class="Data-Kanban">
    <div class="header">
      <!-- <div class="titlebar">
        <img @click="$router.go(-1)" src="../../../assets/refund/ic_Back_line_16_W@2x.png" alt="">
      </div> -->
      <div class="title-box">
        <div class="title">退货</div>
        <div class="point-box">
          <img src="../../../assets/refund/icon_location@2x.png" alt />
          <span v-if="userInfo" class="poin">{{ userInfo.orgName }}</span>
        </div>

      </div>
    </div>
    <div class="body">
      <div class="inner">
        <!-- 累计 -->
        <div class="grandTotal-box">
          <div class="grandTotal">
            <div class="success">
              <p class="subtitle">累计退货成功</p>
              <p class="number">
                {{ CumulativeReturnSucceeded }}
                <span>起</span>
              </p>
            </div>
            <div class="amount">
              <p class="subtitle">累计退款金额</p>
              <p class="number">
                {{ getsuccessMount(CumulativeReturnSucceededMount).num }}
                <span>{{ getsuccessMount(CumulativeReturnSucceededMount).unit }}</span>
              </p>
            </div>
          </div>
          <div class="view" @click="lookAnalyze">
            <img src="../../../assets/refund/icon_MoreData@2x.png" alt />
            <span>查看完整统计分析</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <!-- 录入退货单、关联退货单 -->
        <div v-if="userInfo && userInfo.roleList[0] !== 'Leader'" class="return-form">
          <van-grid :column-num="2" :border="false">
            <van-grid-item @click="createdRefund">
              <img src="../../../assets/refund/icon_TypeIN@2x.png" alt />
              <p class="title">录入退货单</p>
            </van-grid-item>
            <van-grid-item @click="associatedReturnOrder">
              <img src="../../../assets/refund/icon_ConnectOrder@2x.png" alt />
              <p class="title">关联退货单</p>
            </van-grid-item>
          </van-grid>
        </div>
        <p class="chaxun">退货单快捷查询</p>
        <!-- 监理中心的类型 -->
        <van-grid :gutter="9" style="padding-left: 0;" v-if="userInfo && ['Handler', 'leader', 'Leader'].includes(userInfo.roleList[0])" :column-num="2" class="Classification">
          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: '', statusType: -1}})"> -->
          <van-grid-item @click="toList('', -1)">
            <div>
              <span>处理中</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ quickQuery.clzCount }}</p>
          </van-grid-item>
          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: '', statusType: -12}})"> -->
            <van-grid-item @click="toList('', -12)">
            <div>
              <span>退货成功</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ quickQuery.thcgCount }}</p>
          </van-grid-item>
          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: '', statusType: -14}})"> -->
            <van-grid-item @click="toList('', -14)">
            <div>
              <span>不予受理</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ quickQuery.byslCount }}</p>
          </van-grid-item>
          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: '', statusType: 150}})"> -->
          <van-grid-item @click="toList('', 150)">
            <div>
              <span>游客撤销</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ quickQuery.ykcxCount }}</p>
          </van-grid-item>
        </van-grid>
        <!-- 退货中心的类型 -->
        <van-grid
          v-if="userInfo && userInfo.roleList[0] == 'CenterHandler'"
          :column-num="2"
          class="Classification"
        >

          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: 0 }})"> -->
          <van-grid-item @click="toList('0')">
            <div>
              <span>企业未取货</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ companyPick.wqhNum }}</p>
          </van-grid-item>
          <!-- <van-grid-item @click="$router.push({path: '/refund/refundList', query: {pickType: 1 }})"> -->
          <van-grid-item @click="toList(1)">
            <div>
              <span>企业已取货</span>
              <van-icon name="arrow" />
            </div>
            <p>{{ companyPick.yqhNum }}</p>
          </van-grid-item>
        </van-grid>
        <!-- <div class="refundbtn" @click="$router.push({path: '/refund/refundList'})"> -->
        <div class="refundbtn" @click="toList('', '')">
          <span>全部退货单</span>
          <van-icon name="arrow" />
        </div>
        <!-- <van-button class="refundbtn" icon="arrow" color="white" icon-position="right" text="全部退货单" @click="$router.push({path: '/refund/refundList'})"></van-button> -->
      </div>
    </div>
  </div>
</template>

<script>
    import api from '../../../service/modules/refund';
    import common from '../../../utils/common'

    export default {
        filters: {
            moneyFilter (val) {
                return common.numberFormat(val)
            }
        },
        data () {
            return {
                servicePoint: '', // 服务点
                CumulativeReturnSucceeded: '',
                CumulativeReturnSucceededMount: '',
                userInfo: this.$store.state.refund.userInfo,
                quickQuery: {}, // 快捷查询数据
                companyPick: {}
            };
        },
        created () {
            this.currentUser()
            this.returnQuantityAnd();
            this.getEnterpriseWorkBenchAll()
            this.appCompanyPick()
        },
        mounted () {},
        methods: {
            currentUser () {
                api.currentUser().then(res => {
                    if (res.ret === 0) {
                        this.userInfo = res.data
                        this.$store.state.refund.userInfo = res.data
                        console.log('this.$store.state.refund.userInfo', this.$store.state.refund.userInfo)
                    } else {
                        this.userInfo = {}
                    }
                })
            },
            getsuccessMount (val) {
                return common.numberFormat(val)
            },
            appCompanyPick () {
                api.appCompanyPick().then(res => {
                    if (res.ret === 0) {
                        this.companyPick = res.data
                    } else {
                        this.companyPick = {}
                    }
                })
            },
            getEnterpriseWorkBenchAll () {
                api.getEnterpriseWorkBenchAll().then(res => {
                    if (res.ret === 0) {
                        this.quickQuery = res.data
                    } else {
                        this.quickQuery = {}
                    }
                })
            },
            toList (pickType, statusType) {
                // if (!pickType) {
                //     console.log('监理')
                //     window.yyn.invokeJSB(
                //         'openWindow',
                //         {
                //             openUrl: `${this.globalApp.getSystemInfo().host}web/#/refund/refundList?pickType=''&statusType=${statusType}`,
                //             isFullScreen: 0,
                //             setTitle: '退货列表',
                //             needLoading: 1
                //         },
                //         cb => {
                //             console.log(cb, 'callback');
                //         }
                //     );
                // } else if (!statusType) {
                //     console.log('企业')
                //     pickType = Number(pickType)
                //     window.yyn.invokeJSB(
                //         'openWindow',
                //         {
                //             openUrl: `${this.globalApp.getSystemInfo().host}web/#/refund/refundList?pickType=${pickType}`,
                //             isFullScreen: 0,
                //             setTitle: '退货列表',
                //             needLoading: 1
                //         },
                //         cb => {
                //             console.log(cb, 'callback');
                //         }
                //     );
                // }
                this.$store.state.refund.statusType = statusType
                this.$router.push({
                    path: '/refund/refundList',
                    query: {
                        // type: type
                    }
                });
            },
            lookAnalyze () {
                if (this.userInfo && this.userInfo.roleList[0] == 'CenterHandler') {
                    // window.yyn.invokeJSB(
                    //     'openWindow',
                    //     {
                    //         openUrl: this.globalApp.getSystemInfo().host + 'web/#/refund/salesReturnCenter',
                    //         isFullScreen: 0,
                    //         setTitle: '退货统计分析',
                    //         needLoading: 1
                    //     },
                    //     cb => {
                    //         console.log(cb, 'callback');
                    //     }
                    // );

                    this.$router.push({
                        path: '/refund/salesReturnCenter',
                        query: {
                        }
                    });
                } else {
                    // window.yyn.invokeJSB(
                    //     'openWindow',
                    //     {
                    //         openUrl: this.globalApp.getSystemInfo().host + 'web/#/refund/statisticalAnalysis',
                    //         isFullScreen: 0,
                    //         setTitle: '退货统计分析',
                    //         needLoading: 1
                    //     },
                    //     cb => {
                    //         console.log(cb, 'callback');
                    //     }
                    // );
                    this.$router.push({
                        path: '/refund/statisticalAnalysis',
                        query: {
                        }
                    });
                }
            },
            returnQuantityAnd () {
                const param = {
                    dataType: '',
                    endTime: '',
                    orgId: '',
                    reginCode: '',
                    sort: '',
                    startTime: '',
                    value: ''
                };
                api.returnQuantityAnd(param).then(res => {
                    if (res.ret === 0) {
                        this.CumulativeReturnSucceeded = res.data.CumulativeReturnSucceeded;
                        this.CumulativeReturnSucceededMount =
                            res.data.CumulativeReturnSucceededMount;
                    }
                });
            },
            // 录入退货单
            createdRefund () {
                // window.yyn.invokeJSB(
                //     'openWindow',
                //     {
                //         openUrl: this.globalApp.getSystemInfo().host + 'web/#/refund/createdRefund',
                //         isFullScreen: 0,
                //         setTitle: '录入退货单',
                //         needLoading: 1
                //     },
                //     cb => {
                //         console.log(cb, 'callback');
                //     }
                // );
                this.$router.push({
                    path: '/refund/createdRefund'
                });
            },
            // 关联退货单
            associatedReturnOrder () {
                // this.$router.push({
                //     path: '/refund/associatedOrder',
                //     query: {
                //         flowId: '8a8886047d99dcf4017d9a0534230066'
                //     }
                // })
                // 跳转原生进行扫码
                setTimeout(() => {
                    window.yyn.invokeJSB(
                        'openWindow',
                        {
                            openUrl: 'yyngov://scan',
                            isFullScreen: 0,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            // console.log(cb, "callback");
                            // alert(cb);
                        }
                    );
                }, 700);
            }
        }
    };
</script>

<style lang="less" scoped>
.Data-Kanban {
  background-size: 100% 100%;
  .van-icon-arrow:before {
    font-size: 12px;
  }
  .header {
    background: url("../../../assets/refund/bg_headArea@2x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 160px;
    padding: 20px 11px 0 20px;
    position: fixed;
    width: 100%;
    .titlebar {
      margin-bottom: 20px;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .title-box {
      display: flex;
      justify-content: space-between;
    .title {
      font-size: 28px;
      color: #ffffff;
      font-weight: 600;
    }
    .point-box {
      display: flex;
      padding-top: 15px;
      img {
        width: 14px;
        height: 14px;
      }
      .poin {
        font-size: 14px;
        color: #ffffff;
        font-weight: 500;
      }
    }

    }
  }
  .body {

    background-color: #f9fafc;
    padding: 0 12px;
    // min-height: calc(100vh - 150px);
    height: 100vh;
    .inner {
      transform: translateY(62px);
      .grandTotal-box {
        background: #ffffff;
        box-shadow: 0 2px 16px 0 rgba(51, 82, 66, 0.06);
        border-radius: 4px;
        padding: 20px 0 20px 24px;
        margin-bottom: 12px;
        .grandTotal {
          display: flex;
          margin-bottom: 24px;
          .success {
            padding-right: 39px;
            .subtitle {
              font-size: 12px;
              color: #1e2226;
              font-weight: 400;
            }
            .number {
              font-size: 22px;
              color: #1e2226;
              font-weight: bold;
              // line-height: 40px;
              margin-top: 8px;

              span {
                font-size: 12px;
                color: #71747a;
                font-weight: 500;
              }
            }
          }
          .amount {
            border-left: 1px solid #e6e7eb;
            padding-left: 36px;
            .subtitle {
              font-size: 12px;
              color: #1e2226;
              font-weight: 400;
            }
            .number {
              font-size: 22px;
              color: #1e2226;
              font-weight: bold;
              // line-height: 40px;
              margin-top: 8px;
              span {
                font-size: 12px;
                color: #71747a;
                font-weight: 500;
              }
            }
          }
        }
        /deep/.view {
          display: flex;
          align-items: center;
          .van-icon-arrow::before {
            color: #36b374;
          }
          img {
            width: 14px;
            height: 14px;
            margin-right: 3px;
            position: relative;
            bottom: 1px;
          }
          span {
            font-size: 14px;
            color: #36b374;
            font-weight: 600;
            margin-right: 3px;
          }
        }
      }
      /deep/.return-form {
        .van-grid {
          img {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
          }
          .title {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #71747A;
          }
        }
      }
      .chaxun {
        font-weight: 600;
        font-size: 16px;
        color: #1e2226;
        margin: 24px 0 12px 0;
      }
      /deep/.Classification {
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #71747A;
        }
        .van-grid-item:nth-child(even) {
          padding-right: 0 !important;
        }
        
        .van-grid-item__content {
          padding: 16px;
        }
        .van-grid-item__content--center {
          align-items: flex-start;
          div {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 12px;
          }
          p {
            font-size: 20px;
            color: #1e2226;
            font-weight: 600;
          }
        }
      }
      /deep/.refundbtn {
        width: 100%;
        color: #71747a !important;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        background: #FFFFFF;
        border-radius: 2px;
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #71747A;
          line-height: 12px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
